import { useNewsCreation } from "@/src/hooks/features/news/use-news-creation";
import ContentCreationForm from "@/src/utils/content-creation-form";
import { useTranslation } from "react-i18next";

export default function NewsCreationScreen() {
  const { t } = useTranslation();
  const {
    form,
    selectedCategoryIds,
    setSelectedCategoryIds,
    visibility,
    setVisibility,
    groupIds,
    setGroupIds,
    groups,
    visibilityError,
    coverImage,
    setCoverImage,
    attachments,
    handleAddAttachments,
    handleRemoveAttachment,
    infoModal,
    confirmModal,
    handleCreate,
    handleSaveDraft,
    handleCancel,
    isSubmitting,
  } = useNewsCreation();

  return (
    <>
      <ContentCreationForm
        title={t("LABEL_NEWS_CREATION")}
        onBack={handleCancel}
        control={form.control}
        contentField="Content"
        fields={[
          { name: "Title", label: t("HINT_NEWS_TITLE"), placeholder: t("HINT_ENTER_NEWS_TITLE") },
          { name: "Content", label: t("HINT_NEWS_CONTENT"), placeholder: t("HINT_ENTER_NEWS_CONTENT") },
        ]}
        categoryEntityType="news"
        selectedCategoryIds={selectedCategoryIds}
        onSelectedCategoryIdsChange={setSelectedCategoryIds}
        showVisibility
        visibility={visibility}
        onVisibilityChange={setVisibility}
        groupIds={groupIds}
        onGroupIdsChange={setGroupIds}
        groups={groups}
        visibilityError={visibilityError}
        coverImage={coverImage}
        onCoverImageChange={setCoverImage}
        coverImageLabel={t("LABEL_NEWS_COVER_IMAGE")}
        attachments={attachments}
        onAddAttachments={handleAddAttachments}
        onRemoveAttachment={handleRemoveAttachment}
        showAttachments
        isLoading={isSubmitting}
        loadingText={t("LABEL_PUBLISHING")}
        loadingSubText={t("LABEL_PUBLISHING_PLEASE_WAIT")}
        secondaryAction={{ label: t("BTN_CANCEL"), onPress: handleCancel, disabled: isSubmitting }}
        primaryActions={[
          { label: t("BTN_CREATE_NEWS"), onPress: handleCreate, loading: isSubmitting },
          { label: t("BTN_SAVE"), onPress: handleSaveDraft, loading: isSubmitting },
        ]}
        infoModal={infoModal}
        showPinToggle
        confirmModal={confirmModal}
        isPinned={form.watch("isPinned")}
        onPinChange={(val) => form.setValue("isPinned", val)}
      />
    </>
  );
}
